(function () {
  'use strict';

  class UosCtrl {

    constructor($q, Restangular, Uos, AlertMessage, ServiceVfiltro, FactoryVfiltro, $translate) {
      this.q = $q;
      this.restangular = Restangular;
      this.uoService = Uos;
      this.alertMessage = AlertMessage;
      this.veiculos = {};
      this.translate = $translate;

      ServiceVfiltro.init(FactoryVfiltro.get([]))
        .then(() => {
          this.roleVisualizar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('UO_VISUALIZAR');
          this.roleCadastrar = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('UO_EDITAR');
          this.roleAdminVeltec = ServiceVfiltro.factoryVfiltro.authenticator.hasRole('ADMIN_VELTEC');
          this.carregarUos();
        });
      this.limit = 20;
      this.pai = -1;
    }

    loadMore() {
      this.limit += 20;
    }

    carregarUos() {
      if (this.roleVisualizar) {
        this.q.all([
          this.uoService.getFilhas(),
          this.restangular.one('/veiculo/contagem-veiculos/uos').get()
        ])
        .then(data => {
          this.uos = this.converterEmLista(data[0]);
          this.pai = this.uos[0].id;
          this.veiculos = data[1];
        });
      } else {
        this.alertMessage.create({
          type: 'error',
          timeout: 60000,
          message: 'Você não possui permissão para este recurso do sistema!',
          appendTo: '.alerta-aqui'
        });
      }
    }

    toggleFilhas(uo) {
      uo.open = !uo.open;
      this.uos.forEach(item => {
        if (item.pais.indexOf(uo.id) >= 0) {
          item.show = uo.open;
        }
      });
    }

    converterEmLista(uoArvore) {
      let uoLista = [];
      uoLista.push({
        id: uoArvore.id,
        nome: uoArvore.nome,
        arvoreNivel: 0,
        idSav: uoArvore.id_sav,
        parceiras: uoArvore.uosParceiras && uoArvore.uosParceiras.length || 0,
        temFilhas: angular.isDefined(uoArvore.uosfilhas) && uoArvore.uosfilhas.length > 0,
        open: angular.isDefined(uoArvore.uosfilhas) && uoArvore.uosfilhas.length > 0,
        pais: [],
        show: true
      });
      if (angular.isDefined(uoArvore.uosfilhas)) {
        uoLista = uoLista.concat(this.getFilhas(uoArvore, [], 1));
      }
      return uoLista;
    }

    getFilhas(uoArvore, pais, arvoreNivel) {
      const parents = pais.concat([uoArvore.id]);
      return [].concat.apply([],
        uoArvore
        .uosfilhas
        .sort(this.sortByName)
        .map(u => {
          var filhasLista = [];
          filhasLista.push({
            id: u.id,
            nome: u.nome,
            arvoreNivel: arvoreNivel,
            idSav: u.id_sav,
            parceiras: u.uosParceiras && u.uosParceiras.length || 0,
            temFilhas: angular.isDefined(u.uosfilhas) && u.uosfilhas.length > 0,
            open: angular.isDefined(u.uosfilhas) && u.uosfilhas.length > 0,
            pais: parents,
            show: true
          });
          if (angular.isDefined(u.uosfilhas) && u.uosfilhas.length > 0) {
            filhasLista = filhasLista.concat(this.getFilhas(u, parents, arvoreNivel + 1));
          }
          return filhasLista;
        }));
    }

    sortByName(uo1, uo2) {
      if (uo1.nome < uo2.nome) {
        return -1;
      }
      if (uo1.nome > uo2.nome) {
        return 1;
      }
      return 0;
    }

  }

  /**
   * @ngdoc object
   * @name uos.controller:UosCtrl
   *
   * @description
   *
   */
  angular
    .module('uos')
    .controller('UosCtrl', UosCtrl);
}());
